export enum OrgInvitationStatus {
  'PENDING' = 1,
  'ACCEPTED' = 2,
  'DECLINED' = 3,
  'CANCELED' = 4,
}